export const environment = {
  production: false
};

export class EnvSettings {
  public static environmentSettingsFile = 'Develop & Test';
  public static baseUrlBackend = 'https://goles-test.tenfield.com.uy/tenfield-player';
  public static clientId = 'm¶¶ñÇ\u001bã~wãøñÿzÑÝ»óÍ\u001eá·6';
  public static debug = true;
  public static showErrorsInConsole = true;
  public static notAuthorizedVideoURL = 'https://goles-test.tenfield.com.uy/assets/videos/401.mp4';
  public static signUpURL = 'https://goles-test.tenfield.com.uy.com/registro';
  public static playerURL = 'https://goles-test.tenfield.com.uy/player';
  public static emptyPlaylistVideoURL = 'https://www.youtube.com/watch?v=bqThSQK4nTA';
  public static externalLoginURL = 'https://goles-test.tenfield.com.uy/tenfield-player/com.tenfield.player.core.servicios.aexternallogin?TipoAutenticacion=';
  public static backendRedirectURL = 'https://goles-test.tenfield.com.uy/backend-callback';
  public static redirectURLAfterSuccessfulSubscription = 'https://www.tenfield.com.uy';
  public static redirectionAfterSuccessfulSubscriptionTimeout = 15000;
}
